import { ApiError } from '@teko/api';
import { t } from './i18n.es.js';

const errorMessageMapping = new Map([
    [400001, 'Dữ liệu không hợp lệ'],
    [400100, 'Dữ liệu loyalty không hợp lệ'],
    [400101, 'Dữ liệu loyalty ngoài giá trị cho phép'],
    [400102, 'Nhập thiếu giá trị bắt buộc'],
    [400120, 'Giá trị không nằm trong tập cho phép'],
    [
        400310,
        'Trả góp chỉ áp dụng cho đơn hàng có giá trị từ 3 triệu đồng trở lên',
    ],
    [400320, 'Dữ liệu Takashimaya không hợp lệ'],
    [400321, 'Dữ liệu Takashimaya ngoài giá trị cho phép'],
    [400322, 'Nhập thiếu giá trị bắt buộc'],
    [400330, 'Giá trị không nằm trong tập cho phép'],
    [403104, 'Không có quyền truy cập Loyalty'],
    [403116, 'Không có quyền truy cập loyalty'],
    [403116, 'Không có quyền truy cập'],
    [403331, 'Không có quyền truy cập Takashimaya'],
    [404117, 'Không tìm thấy cấu hình loyalty network'],
    [404123, 'Không tìm thấy chứng chỉ xác thực loyalty'],
    [404124, 'Không tìm thấy loyalty tier'],
    [409121, 'Số điện thoại đã được sử dụng'],
    [409125, 'Chứng chỉloyalty đã được sử dụng'],
    [409323, 'Thành viên đã tồn tại'],
    [409323, 'Thẻ thành viên này đã được liên kết với một tài khoản khác'],
    [409324, 'Số điện thoại và mã thẻ không trùng khớp'],
    [409328, 'Số điện thoại đã được sử dụng'],
    [409332, 'Số điện thoại cho Takashimaya đã được sử dụng'],
    [423122, 'Loyalty network không hoạt động'],
    [423126, 'Loyalty merchant không hoạt động'],
    [423333, 'Takashimaya network không hoạt động'],
    [
        429325,
        'Số điện thoại và mã thẻ không trùng khớp. Tạm khóa chức năng liên kết trong 1 giờ.',
    ],
    [500202, 'Vui lòng cập nhật số điện thoại'],
    [500329, 'Không cùng thuộc Takashimaya network'],
]);
const getError = (resp) => {
    const tKey = errorMessageMapping.get(resp.code);
    if (!tKey)
        return null;
    const message = t(tKey);
    return new ApiError(message, resp.code, resp);
};

export { getError };
